import React, { FC, useCallback, useEffect } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { BlueButton, NavButton } from 'components/Button'
import { Description, MainHeadline } from 'components/Typography'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { initCampaigns } from 'reducks/campaign/operations'

const CampaignTemplate: FC = () => {
  const dispatch = useDispatch()
  const goToCampaignCreatePage = useCallback(() => dispatch(push('/admin/campaign_cms/create')), [dispatch])
  const goToCampaignListPage = useCallback(() => dispatch(push('/admin/campaign_cms/list')), [dispatch])
  useEffect(() => {
    dispatch(initCampaigns())
  }, [])
  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={'キャンペーン'} />
      <Spacer size={20} />
      <Description description={'アプリで実施するキャンペーンの作成を行います。'} />
      <Spacer size={20} />
      <Description description={'新しくキャンペーンを登録する場合は、こちらより行ってください。'} fontWeight={'bold'} />
      <Spacer size={20} />
      <BlueButton
        endIconPath={'/icon/white/arrow_next_small.svg'}
        label={'キャンペーンを作成する'}
        onClick={goToCampaignCreatePage}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={20} />
      <Description
        description={'キャンペーンの一覧の確認や、キャンペーン内容を編集する場合はこちらより行ってください。'}
        fontWeight={'bold'}
      />
      <Spacer size={20} />
      <BlueButton
        endIconPath={'/icon/white/arrow_next_small.svg'}
        label={'キャンペーン一覧'}
        onClick={goToCampaignListPage}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={48} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/admin/shops'} />
      <Spacer size={72} />
    </div>
  )
}

export default CampaignTemplate
